import PropTypes from "prop-types";
import { Plus, Trash2 } from "lucide-react";
import { formatPrice } from "../../../../components/catalog/catalogUtils.js";

/**
 * Tramos de precio de un modelo del proyecto (C3D-38): «desde N uds, X € / ud».
 * Un solo tramo vale como precio único. El orden se arregla al guardar.
 */
export default function PriceTiersEditor({ tiers, onChange, stockPrice = null, disabled = false }) {
    const update = (index, field, value) => {
        onChange(tiers.map((tier, i) => (i === index ? { ...tier, [field]: value } : tier)));
    };
    const remove = (index) => onChange(tiers.filter((_, i) => i !== index));
    const add = () => {
        const last = tiers[tiers.length - 1];
        onChange([...tiers, {
            min_quantity: last ? Number(last.min_quantity || 0) * 2 || 50 : 1,
            unit_price: last?.unit_price ?? stockPrice ?? "",
        }]);
    };

    return (
        <div className="flex flex-col gap-2">
            {tiers.length === 0 && (
                <p className="text-xs text-base-content/60">
                    {stockPrice ? `Sin tramos se enseña el precio de la tienda (${formatPrice(stockPrice)}).` : "Añade al menos un tramo para enseñar precio."}
                </p>
            )}
            {tiers.map((tier, index) => (
                <div key={index} className="grid grid-cols-[1fr_1fr_auto] gap-2 items-end">
                    <label className="form-control">
                        <span className="label-text text-xs">Desde (uds)</span>
                        <input
                            type="number"
                            min="1"
                            step="1"
                            className="input input-bordered input-sm w-full"
                            value={tier.min_quantity}
                            onChange={(event) => update(index, "min_quantity", event.target.value)}
                            disabled={disabled}
                        />
                    </label>
                    <label className="form-control">
                        <span className="label-text text-xs">Precio / ud (€)</span>
                        <input
                            type="number"
                            min="0"
                            step="0.01"
                            className="input input-bordered input-sm w-full"
                            value={tier.unit_price}
                            onChange={(event) => update(index, "unit_price", event.target.value)}
                            disabled={disabled}
                        />
                    </label>
                    <button
                        type="button"
                        className="btn btn-ghost btn-sm btn-square"
                        onClick={() => remove(index)}
                        aria-label="Quitar tramo"
                        disabled={disabled}
                    >
                        <Trash2 className="w-4 h-4" aria-hidden="true" />
                    </button>
                </div>
            ))}
            <button type="button" className="btn btn-ghost btn-xs gap-1 self-start" onClick={add} disabled={disabled}>
                <Plus className="w-3.5 h-3.5" aria-hidden="true" /> Añadir tramo
            </button>
        </div>
    );
}

PriceTiersEditor.propTypes = {
    tiers: PropTypes.arrayOf(PropTypes.shape({
        min_quantity: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        unit_price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    })).isRequired,
    onChange: PropTypes.func.isRequired,
    stockPrice: PropTypes.string,
    disabled: PropTypes.bool,
};
